import { render, staticRenderFns } from "./EditCookieStatusDialog.vue?vue&type=template&id=c0156494&scoped=true"
import script from "./EditCookieStatusDialog.vue?vue&type=script&lang=ts"
export * from "./EditCookieStatusDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0156494",
  null
  
)

export default component.exports